import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {ProleisObject, Task, UserService} from 'proleis-rest-client';
import {PpsService} from '../pps.service';

@Component({
  selector: 'p4m-pps-lane',
  templateUrl: 'lane.component.html',
})
export class LaneComponent implements OnInit {
  @Input() laneTitle: string;
  @Input() tasks: Observable<Task[]>;

  @Output() filterEvent: EventEmitter<string> = new EventEmitter<string>();

  user$: Observable<ProleisObject>;

  constructor(
    public ppsService: PpsService,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this.user$ = this.userService.getCurrentUser();
  }

  fireFilterEvent() {
    this.filterEvent.emit('');
  }
}
